import { ErrorAlert } from '@/components';
import { UnknownSpec } from '@/core';
import { OptionsEditorProps, PluginType } from '../../../model';
import { usePlugin } from '../../../runtime';

export interface PluginSpecEditorProps extends OptionsEditorProps<UnknownSpec> {
  pluginType: PluginType;
  pluginKind: string;
}

export function PluginSpecEditor(props: PluginSpecEditorProps) {
  const { pluginType, pluginKind, ...others } = props;
  const { data: plugin, isLoading, error } = usePlugin(pluginType, pluginKind);

  if (error) {
    return <ErrorAlert error={error} />;
  }

  // TODO: Proper loading indicator
  if (isLoading) {
    return null;
  }

  if (plugin === undefined) {
    throw new Error(`Missing implementation for ${pluginType} plugin with kind '${pluginKind}'`);
  }

  if (pluginType === 'Panel') {
    throw new Error('This editor should not be used for panel type. Please use Panel Spec Editor instead.');
  }

  const { OptionsEditorComponent } = plugin;

  if (OptionsEditorComponent !== undefined) {
    return <OptionsEditorComponent {...others} />;
  }

  return null;
}
